// Keep Judge.me's live data, stars and click handlers; only format the summary.
(() => {
  if (customElements.get('ultra-review-summary')) return;

  class UltraReviewSummary extends HTMLElement {
    connectedCallback() {
      this.observer ||= new MutationObserver(() => this.update());
      this.update();
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }

    update() {
      // Ignore our own text changes, but catch later app hydration/replacements.
      this.observer.disconnect();
      this.querySelectorAll('.jdgm-prev-badge').forEach(badge => {
        const rawCount = badge.getAttribute('data-number-of-reviews');
        const rawRating = badge.getAttribute('data-average-rating');
        const count = rawCount?.trim() ? Number(rawCount) : NaN;
        const rating = rawRating?.trim() ? Number(rawRating) : NaN;
        const text = badge.querySelector('.jdgm-prev-badge__text');
        const stars = badge.querySelector('.jdgm-prev-badge__stars');
        let score = badge.querySelector('.UltraReviewScore');

        if (Number.isInteger(count) && count >= 0 && text) {
          const label = count === 1 ? this.dataset.singleReviewLabel : this.dataset.reviewLabel;
          text.textContent = `${count} ${label || (count === 1 ? 'Review' : 'Reviews')}`;
        }

        if (this.dataset.showScore !== 'false' && count > 0 && Number.isFinite(rating) && rating >= 0 && rating <= 5 && stars) {
          if (!score) {
            score = document.createElement('span');
            score.className = 'UltraReviewScore';
            badge.insertBefore(score, stars);
          }
          score.textContent = rating.toFixed(1);
        } else {
          score?.remove();
        }
      });
      this.observer.observe(this, {
        childList: true,
        subtree: true,
        characterData: true,
        attributes: true,
        attributeFilter: ['data-average-rating', 'data-number-of-reviews']
      });
    }
  }

  customElements.define('ultra-review-summary', UltraReviewSummary);
})();


if (!customElements.get('ultra-help-video')) {
  customElements.define('ultra-help-video', class extends HTMLElement {
    connectedCallback() {
      if (this.openVideo) return;
      this.openVideo = () => {
        if (this.dialog) return;
        const id = this.dataset.videoId;
        if (!/^[a-zA-Z0-9_-]{11}$/.test(id)) return;
        const dialog = document.createElement('dialog');
        dialog.className = 'UltraHelpVideo';
        dialog.setAttribute('aria-label', 'Mips video');
        const close = document.createElement('button');
        close.type = 'button'; close.textContent = '×';
        close.setAttribute('aria-label', 'Close video');
        const frame = document.createElement('iframe');
        frame.title = 'Mips video';
        frame.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
        frame.allowFullscreen = true;
        frame.referrerPolicy = 'strict-origin-when-cross-origin';
        frame.src = 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&playsinline=1&rel=0';
        dialog.append(close, frame);
        document.body.append(dialog); this.dialog = dialog;
        close.addEventListener('click', () => dialog.close());
        dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
        dialog.addEventListener('close', () => {
          frame.src = 'about:blank'; dialog.remove(); this.dialog = null;
          this.querySelector('button')?.focus({ preventScroll: true });
        }, { once: true });
        dialog.showModal(); close.focus();
      };
      this.addEventListener('click', this.openVideo);
    }
    disconnectedCallback() {
      this.dialog?.close(); this.dialog?.remove(); this.dialog = null;
      this.removeEventListener('click', this.openVideo);
      this.openVideo = null;
    }
  });
}
